import { LayoutDashboard } from 'lucide-react';
import React from 'react'
import { Link, useLocation } from 'react-router-dom';
import PO_ROUTE_URLS from '../../../Routes/PoTeam/PoRoutes';

const Sidebar = () => {
    const location = useLocation();


    return (
        <div className="sidebar" id="sidebar">
            <div className="sidebar-inner slimscroll side-bar-scroll">
                <div id="sidebar-menu" className="sidebar-menu">
                    <ul>
                        <li>
                            <Link
                                to={PO_ROUTE_URLS.HOME}
                                className={`${location.pathname === PO_ROUTE_URLS.HOME ? "active" : ""}`}>
                                <span className="menu-side"><LayoutDashboard className="Dash-iCon" /> </span>
                                <span>Dashboard </span>
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={PO_ROUTE_URLS.MTO}
                                className={`${location.pathname === PO_ROUTE_URLS.MTO ? "active" : ""}`}>
                                <span className="menu-side"><LayoutDashboard className="Dash-iCon" /> </span>
                                <span>Material MTO </span>
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={PO_ROUTE_URLS.PR}
                                className={`${location.pathname === PO_ROUTE_URLS.PR ? "active" : ""}`}>
                                <span className="menu-side"><LayoutDashboard className="Dash-iCon" /> </span>
                                <span>Prepare PR </span>
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={PO_ROUTE_URLS.INQUIRY}
                                className={`${location.pathname === PO_ROUTE_URLS.INQUIRY ? "active" : ""}`}>
                                <span className="menu-side"><LayoutDashboard className="Dash-iCon" /> </span>
                                <span>Generate Inquiry</span>
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={PO_ROUTE_URLS.OFF_COM}
                                className={`${location.pathname === PO_ROUTE_URLS.OFF_COM ? "active" : ""}`}>
                                <span className="menu-side"><LayoutDashboard className="Dash-iCon" /> </span>
                                <span>Offer Comparision</span>
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={PO_ROUTE_URLS.CONTER_OFF}
                                className={`${location.pathname === PO_ROUTE_URLS.CONTER_OFF ? "active" : ""}`}>
                                <span className="menu-side"><LayoutDashboard className="Dash-iCon" /> </span>
                                <span>Counter Offer</span>
                            </Link>
                        </li>

                        <li>
                            <Link
                                to={PO_ROUTE_URLS.ORDER_PLACE}
                                className={`${location.pathname === PO_ROUTE_URLS.ORDER_PLACE ? "active" : ""}`}>
                                <span className="menu-side"><LayoutDashboard className="Dash-iCon" /> </span>
                                <span>Order Placement</span>
                            </Link>
                        </li>


                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Sidebar